import {
  FETCH_CARE_PLAN_TASKS,
  FETCH_CARE_PLAN_TASKS_SUCCESS,
  FETCH_CARE_PLAN_TASKS_FAILURE,
  ADD_CARE_PLAN_TASK,
  ADD_CARE_PLAN_TASK_SUCCESS,
  ADD_CARE_PLAN_TASK_FAILURE,
  EDIT_CARE_PLAN_TASK,
  EDIT_CARE_PLAN_TASK_SUCCESS,
  EDIT_CARE_PLAN_TASK_FAILURE,
  DELETE_CARE_PLAN_TASK,
  DELETE_CARE_PLAN_TASK_SUCCESS,
  DELETE_CARE_PLAN_TASK_FAILURE,
  FETCH_CARE_PLAN_TASK_TEMPLATES,
  FETCH_CARE_PLAN_TASK_TEMPLATES_SUCCESS,
  FETCH_CARE_PLAN_TASK_TEMPLATES_FAILURE,
  MARK_CARE_PLAN_TASK_STATUS,
  MARK_CARE_PLAN_TASK_STATUS_SUCCESS,
  MARK_CARE_PLAN_TASK_STATUS_FAILURE,
} from "./constants";

export const fetchCarePlanTasks = (payload, onSuccess) => ({
  type: FETCH_CARE_PLAN_TASKS,
  payload,
  onSuccess,
});
export const fetchCarePlanTasksSuccess = (payload) => ({
  type: FETCH_CARE_PLAN_TASKS_SUCCESS,
  payload,
});
export const fetchCarePlanTasksFailure = () => ({
  type: FETCH_CARE_PLAN_TASKS_FAILURE,
});

export const addCarePlanTask = (payload, onSuccess) => ({
  type: ADD_CARE_PLAN_TASK,
  payload,
  onSuccess,
});
export const addCarePlanTaskSuccess = (payload) => ({
  type: ADD_CARE_PLAN_TASK_SUCCESS,
  payload,
});
export const addCarePlanTaskFailure = () => ({
  type: ADD_CARE_PLAN_TASK_FAILURE,
});

export const editCarePlanTask = (payload, onSuccess) => ({
  type: EDIT_CARE_PLAN_TASK,
  payload,
  onSuccess,
});
export const editCarePlanTaskSuccess = (payload) => ({
  type: EDIT_CARE_PLAN_TASK_SUCCESS,
  payload,
});
export const editCarePlanTaskFailure = () => ({
  type: EDIT_CARE_PLAN_TASK_FAILURE,
});

export const deleteCarePlanTask = (payload, onSuccess) => ({
  type: DELETE_CARE_PLAN_TASK,
  payload,
  onSuccess,
});
export const deleteCarePlanTaskSuccess = (payload) => ({
  type: DELETE_CARE_PLAN_TASK_SUCCESS,
  payload,
});
export const deleteCarePlanTaskFailure = () => ({
  type: DELETE_CARE_PLAN_TASK_FAILURE,
});

export const fetchCarePlanTaskTemplates = (payload, onSuccess) => ({
  type: FETCH_CARE_PLAN_TASK_TEMPLATES,
  payload,
  onSuccess,
});
export const fetchCarePlanTaskTemplatesSuccess = (payload) => ({
  type: FETCH_CARE_PLAN_TASK_TEMPLATES_SUCCESS,
  payload,
});
export const fetchCarePlanTaskTemplatesFailure = () => ({
  type: FETCH_CARE_PLAN_TASK_TEMPLATES_FAILURE,
});

// payload: { id, data } where data = { is_completed: "true"|"false" } |
// { is_skipped: "true"|"false" } (+ optional notes). Hits POST mark-done/{id}.
export const markCarePlanTaskStatus = (payload, onSuccess) => ({
  type: MARK_CARE_PLAN_TASK_STATUS,
  payload,
  onSuccess,
});
export const markCarePlanTaskStatusSuccess = (payload) => ({
  type: MARK_CARE_PLAN_TASK_STATUS_SUCCESS,
  payload,
});
export const markCarePlanTaskStatusFailure = () => ({
  type: MARK_CARE_PLAN_TASK_STATUS_FAILURE,
});
